module.exports = __webpack_public_path__ + "static/media/avatar-girl.5261bd49.png";